const placeholderTemplates = new Map([
    ["CLIMBING", "Group / Private X-day expedition via ROUTENAME incl. airport transfers & 2 hotel nights (MEALPLAN)"],
    ["CLIMBING_RENTAL", "Personal gear rent (ITEMNAME)"],
    ["CLIMBING_EXTRA", "Portable Toilet (1 unit suffices for max. 3 participants) / Portable Shower (1 unit suffices for max. 3 participants) / Services of a private porter for the entire duration of the climb (carries up to 15 kg) / Single tent on Kilimanjaro / Bottled water for drinking / Bottled water for drinking & cooking"],
    ["SAFARI", "Group / Private X-day safari in PARKNAMES (accommodation and meals as per program description)"],
    ["SAFARI_ACTIVITY", "Hot Air Balloon Flight in Serengeti (start from hotel at about [TIME] AM, festive English breakfast included)"],
    ["CUSTOM", "Portable Toilet / Portable Shower (1 unit suffices for max. 3 participants)"],
    ["EXTRA_ACCOMMODATION", "Extra night at HOTELNAME (ROOMTYPE, MEALPLAN)"],
    ["FLIGHT", "Flight FROM-TO by AIRLINENAME, TIME-TIME (X kg luggage included)"],
    ["ISLAND", "Night at HOTELNAME (ROOMS' QTY, ROOMTYPE, MEALPLAN)"],
    ["ISLAND_TRANSFER", "Transfer from NAME to NAME (Return / One-Way)"],
    ["ISLAND_DAY_TRIP", "Day trip to TRIPNAME"],
    ["AIRPORT_VIP_SERVICE", "VIP lounge and fast track at Kilimanjaro International Airport for [Arrival / Departure]"],
])

export const getPlaceholderTemplates = () => {
    return placeholderTemplates;
}